module.exports = __webpack_public_path__ + "static/media/Citrix.a0f98ad8.svg";